export default __webpack_public_path__ + "static/media/property_194.03ec101d.png";